import React from 'react';

const Header = (props) =>{
    return(
        <div>
                <h1>Tomas Benitez</h1>
                <h2>Electricidad y Refrigeración</h2>
        </div> 
    );
}
export {Header};